import { TransferList } from './TransferList';
export default TransferList;
